import { useEffect, useRef } from "react";
import { builderCopy as copy, fill, nounValues } from "./copy";
import { SelectionPanel, type SelectionPanelProps } from "./SelectionPanel";

/**
 * Build on a phone (KEY-560): the sections as a list under the wheel, which shrinks to a thumbnail that stays in view. Opening a
 * section shows the same panel the wide layout has beside the wheel, in place. Both layouts are on the page and the stylesheet
 * shows one, so a selection made on the thumbnail opens its section here.
 */
export function BuildList({ model, resolved, noun, disabled, dispatch, onSelect }: SelectionPanelProps) {
  const words = nounValues(noun);
  const openKey = resolved ? model.sections[resolved.sectionIndex].key : null;
  const openRef = useRef<HTMLLIElement>(null);
  const selected = resolved ? JSON.stringify(resolved.selection) : "";

  // A tap on the thumbnail, or "Fix this", can open a section further down. Only when the list is the layout showing.
  useEffect(() => {
    const row = openRef.current;
    if (row && row.offsetParent !== null) row.scrollIntoView?.({ block: "nearest" });
  }, [selected]);

  return (
    <div className="kd-build-list">
      {model.sections.length > 0 && (
        <ol className="kd-build-list-sections">
          {model.sections.map((section) => {
            const open = section.key === openKey;
            return (
              <li key={section.key} ref={open ? openRef : undefined} className="kd-build-list-section" data-open={open}>
                <button
                  type="button"
                  className="kd-build-list-head"
                  aria-expanded={open}
                  onClick={() => onSelect(open ? null : { level: "section", sectionKey: section.key })}
                >
                  <span className="kd-build-list-name">{section.label || copy.build.untitled}</span>
                  <span className="kd-build-list-meta">{fill(copy.build.listHeading, { ...words, n: section.segments.length })}</span>
                </button>
                {open && <SelectionPanel model={model} resolved={resolved} noun={noun} disabled={disabled} dispatch={dispatch} onSelect={onSelect} />}
              </li>
            );
          })}
        </ol>
      )}
      <div className="kd-panel-actions">
        <button type="button" className="kd-btn" disabled={disabled} onClick={() => dispatch({ type: "addSection" })}>
          {copy.build.addSection}
        </button>
      </div>
    </div>
  );
}
